import { wait } from '@/__mocks__/util/async.ts'
import { status } from '@/__mocks__/config.ts'
import { currencyPaymentBank } from '@/__mocks__/modules/wallet/data.ts'

export default [
  {
    method: 'GET',
    path: '/currency-payment-bank',
    reply: async () => {
      await wait()
      return [status.ok, currencyPaymentBank]
    }
  },
  {
    method: 'POST',
    path: '/payment/report-payment',
    reply: async () => {
      await wait()
      return [status.ok, { status: 'PENDING' }]
    }
  }
]
